export const GET_USER_DETAILS_API_PATH = '/loggedin_user';
export const GET_USER_TOKEN_API_PATH = '/userServiceCommonData';
export const GET_ACTIVE_FIRM_API_PATH = '/businessunit';
export const GET_FACTORS_API_PATH = '/factor';
export const GET_TENANT_ID = '/auth?name=';
export const GET_USER_PERMISSIONS = '/feature';
export const GET_BFF_USERS_API_PATH = '/user';

export const GET_ALL_DEVICES_API_PATH = '/api/fetch/deviceId';
export const SERVICE = '/service';
export const API = '/api';
export const AUTH_API = '/auth';
